import { Component, Input, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
@Component({
  selector: 'app-medical-certificate',
  templateUrl: './medical-certificate.component.html',
  styleUrls: ['./medical-certificate.component.css']
})
export class MedicalCertificateComponent implements OnInit {
  @Input() data: any;
  @Input() certificateDetails: any;
  certForm!: FormGroup;
  today: string = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
  todayDate: Date = new Date();
  unfitFromMinDate: Date = this.todayDate;
  unfitToMinDate: Date = this.todayDate;
  returnDateMinDate: Date = this.todayDate;
  doctorDetails:any
  addressNotRegistered = false;
  orgDetails:any
  certificate_Details:any

  constructor(private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private masterService: MasterService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private http: HttpClient,
    private modalService: NgbModal
  ) {
 
  }

  ngOnInit(){
    // console.log('MedicalCertificateComponent data:', this.data);
    this.doctorDetails = JSON.parse(sessionStorage.getItem('doctorDetails') || sessionStorage.getItem('DoctorDetails') || '{}');
    // this.orgDetails = JSON.parse(sessionStorage.getItem('tenantDtls') || '{}')?.data || {};
    this.initform();
    this.patchDetails();
  }
  patchDetails() {
    if (this.data) {
      // this.addressNotRegistered = !this.data.address || !String(this.data.address).trim();
      // const signatureDocument = this.doctorDetails?.doctor_documents
      //   ?.find((document: any) => document.file_type_id == 8);
      // const signatureUrl = signatureDocument?.document_path && this.doctorDetails?.id
      //   ? `${this.regService.viewFilePath}DOCTOR/${this.doctorDetails.id}/DigitalSignature/${signatureDocument.document_path}`
      //   : '';

      this.certForm.patchValue({
        // date: this.datePipe.transform(this.today, 'dd-MM-yyyy'),
        patientName: [this.data.first_name, this.data.middle_name, this.data.last_name]
          .filter(name => name)
          .join(' '),
        dob: this.data.birth_date || '',
        tel: this.data.member_mobile || this.data.mobile || '',
        patientAddress: this.data.address || '',
        practitionerName: [this.doctorDetails?.first_name, this.doctorDetails?.last_name]
          .filter(name => name)
          .join(' '),
        regNo: this.doctorDetails?.mci_number || '',
        // signature: signatureUrl
      });

      if (this.certificateDetails) {
        this.certForm.patchValue({
          examinationDate: new Date(this.certificateDetails.patientExaminedDate),
          unfitFrom: new Date(this.certificateDetails.medicalUnfitFrom),
          unfitTo: new Date(this.certificateDetails.medicalUnfitTo),
          returnDate: new Date(this.certificateDetails.returnToWorkOrSchoolDate),
          employerOrSchool: this.certificateDetails.employerOrSchool,
          diagnosis: this.certificateDetails.diagnosisOrClinicalNotes
        });

      }

      this.certForm.get('patientName')?.disable();
      this.certForm.get('dob')?.disable();
      this.certForm.get('tel')?.disable();
      this.certForm.get('date')?.disable();
      this.certForm.get('patientAddress')?.disable();
      this.certForm.get('practitionerName')?.disable();
      this.certForm.get('regNo')?.disable();
      this.certForm.get('signature')?.disable();
    }
  }

  initform(){
    this.certForm = this.fb.group({
      date: [this.datePipe.transform(this.today, 'dd-MM-yyyy')],
      patientName: [''],
      dob: [''],
      tel: [''],
      patientAddress: [''],
      examinationDate: [this.todayDate, Validators.required],
      unfitFrom: ['', Validators.required],
      unfitTo: ['', Validators.required],
      returnDate: ['', Validators.required],
      employerOrSchool: [''],
      diagnosis: [''],
      practitionerName: [''],
      regNo: [''],
      signature: ['']
    });
  }

  onExaminationDateChange(date: Date): void {
    if (date) {
      this.unfitFromMinDate = date;
      this.unfitToMinDate = date;
      this.returnDateMinDate = date;
    }
  }

  onUnfitFromChange(date: Date): void {
    if (date) {
      this.unfitToMinDate = date;
      this.returnDateMinDate = date;
    }
  }

  onUnfitToChange(date: Date): void {
    if (date) {
      this.returnDateMinDate = date;
    }
  }

  onSubmit(): void {
    this.certificate_Details = {
      patientExaminedDate: this.datePipe.transform(this.certForm.get('examinationDate')?.value, 'yyyy-MM-dd'),
      medicalUnfitFrom: this.datePipe.transform(this.certForm.get('unfitFrom')?.value, 'yyyy-MM-dd'),
      medicalUnfitTo: this.datePipe.transform(this.certForm.get('unfitTo')?.value, 'yyyy-MM-dd'),
      returnToWorkOrSchoolDate: this.datePipe.transform(this.certForm.get('returnDate')?.value, 'yyyy-MM-dd'),
      employerOrSchool: this.certForm.get('employerOrSchool')?.value,
      diagnosisOrClinicalNotes: this.certForm.get('diagnosis')?.value,
    };

    const hasCertificateData = Object.keys(this.certificate_Details)
      .some(key => this.certificate_Details[key] !== null && this.certificate_Details[key] !== undefined &&
        String(this.certificate_Details[key]).trim() !== '');

    if (hasCertificateData) {
      if (this.certForm.valid) {
        this.activeModal.close({ certificateDetails: this.certificate_Details });
      } else {
        this.toastr.warning('Please fill all mandatory certificate fields.');
      }
      return;
    }

    if (window.confirm('No certificate details were entered. Close without saving?')) {
      this.toastr.success('Medical certificate closed without changes.');
      this.activeModal.close({ cancelled: true });
    }
}

closeModal(){
    this.activeModal.dismiss('Medical certificate closed without saving');

}
}
